import { Controller } from "@hotwired/stimulus";

// Initialize select2 on the jQuery object
export default class extends Controller {
  connect() {
    // Initialize Select2 when the element is inserted into the DOM
    $(this.element).select2({
      theme: 'bootstrap-5',
      width: '100%',
      sorter: function(data) {
          return data.sort((a, b) => a.text.localeCompare(b.text));
      }
    });
  }

  disconnect() {
    // Destroy Select2 when the element is removed from the DOM or cached
    $(this.element).select2("destroy");
  }
}